const BRIGHT_GREEN_HEX = "#00FF00";
const LEGACY_CSS_GREEN_HEX = "#008000";
const broadcastGreenAliases = new Set(["lime", "green", BRIGHT_GREEN_HEX.toLowerCase(), LEGACY_CSS_GREEN_HEX.toLowerCase()]);
function normalizeColorToken(nameOrHex) {
  if (nameOrHex == null) {
    return "";
  }
  return String(nameOrHex).trim().toLowerCase();
}
function toBroadcastColor(nameOrHex) {
  const normalized = normalizeColorToken(nameOrHex);
  if (broadcastGreenAliases.has(normalized)) {
    return "green";
  }
  return normalized;
}
function toWebColor(nameOrHex) {
  const normalized = normalizeColorToken(nameOrHex);
  if (broadcastGreenAliases.has(normalized)) {
    return "lime";
  }
  return normalized;
}
export default {
  BRIGHT_GREEN_HEX,
  colors: ["black", "red", "lime", "yellow", "blue", "magenta", "cyan", "white"],
  hexColorMapping: {
    black: "#000000",
    red: "#FF0000",
    green: BRIGHT_GREEN_HEX,
    lime: BRIGHT_GREEN_HEX,
    yellow: "#FFFF00",
    blue: "#0000FF",
    magenta: "#FF00FF",
    cyan: "#00FFFF",
    white: "#FFFFFF"
  },
  speakerOrder: ["lime", "yellow", "blue", "magenta", "cyan", "red"],
  toBroadcastColor,
  toWebColor
};